import apiGroupsAthletes from '@/api/groups-athletes'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createGroupsAthletesStart:
    '[create groups athletes] Create groups athletes start',
  createGroupsAthletesSuccess:
    '[create groups athletes] Create groups athletes success',
  createGroupsAthletesFailure:
    '[create groups athletes] Create groups athletes failure'
}

export const actionTypes = {
  createGroupsAthletes: '[create groups athletes] Create groups athletes'
}

const mutations = {
  [mutationTypes.createGroupsAthletesStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createGroupsAthletesSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createGroupsAthletesFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createGroupsAthletes](context, {athlete}) {
    context.commit(mutationTypes.createGroupsAthletesStart)
    return new Promise(resolve => {
      apiGroupsAthletes
        .addGroupsAthlete(athlete)
        .then(response => {
          context.commit(mutationTypes.createGroupsAthletesSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createGroupsAthletesFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
